module.exports = __webpack_public_path__ + "Frame421-6f67d94d.webp";